import {
  AlertCircleIcon,
  AlertTriangleIcon,
  ArcIcon,
  ArrowDownIcon,
  ArrowDownRightIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowUpRightIcon,
  BellIcon,
  BookmarkIcon,
  BroadcastIcon,
  CalendarIcon,
  ChangeLocation,
  ChartIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ClipboardIcon,
  ClockIcon,
  CoinsIcon,
  ConeIcon,
  CopyIcon,
  DocumentationIcon,
  DownloadIcon,
  EllipsisIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FileTextIcon,
  FolderIcon,
  ForbiddenIcon,
  GiftIcon,
  HashIcon,
  HeadphonesIcon,
  HeartIcon,
  HelpCircleIcon,
  HomeIcon,
  InboxIcon,
  InfoIcon,
  LifeBuoyIcon,
  ListIcon,
  LockIcon,
  LogOutIcon,
  MapPinIcon,
  MaximizeIcon,
  MaximizeSquareIcon,
  MenuIcon,
  MessageRoundIcon,
  MessageSquareIcon,
  MinimizeIcon,
  MoveIcon,
  PaperClipIcon,
  PauseIcon,
  PencilIcon,
  PhoneIcon,
  PlayFilledIcon,
  PlayIcon,
  PlusIcon,
  RoadIcon,
  RotateCCWIcon,
  SearchIcon,
  SendIcon,
  SettingsIcon,
  ShoppingCartIcon,
  StarFilledIcon,
  StarIcon,
  SunIcon,
  SunriseIcon,
  ThumbsUpIcon,
  TimerIcon,
  ToggleRightIcon,
  TrashIcon,
  TrendingUpIcon,
  UploadIcon,
  UserIcon,
  UsersIcon,
  VolumeIcon,
  VolumeMuteIcon,
  WheelIcon,
  XCircleIcon,
  XIcon,
  ZapFilledIcon,
  ZapIcon,
} from '@ornikar/kitt-icons';

export const appSet = {
  // legacy imports from the time where we were using font awesome
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  camera: HashIcon,
  /** @deprecated use hash icon instead */
  sharp: HashIcon,
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  power: HashIcon,
  /** @deprecated use shopping-cart icon instead */
  cart: ShoppingCartIcon,
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  document: HashIcon,
  /** @deprecated use search icon instead */
  wen: SearchIcon,

  // Current Icons set
  search: SearchIcon,
  'alert-circle': AlertCircleIcon,
  'alert-triangle': AlertTriangleIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-up-right': ArrowUpRightIcon,
  'arrow-down-right': ArrowDownRightIcon,
  bell: BellIcon,
  bookmark: BookmarkIcon,
  broadcast: BroadcastIcon,
  calendar: CalendarIcon,
  chart: ChartIcon,
  'change-location': ChangeLocation,
  'check-circle': CheckCircleIcon,
  'check-square': CheckSquareIcon,
  check: CheckIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-up': ChevronUpIcon,
  clipboard: ClipboardIcon,
  clock: ClockIcon,
  cross: XIcon,
  cone: ConeIcon,
  copy: CopyIcon,
  'cross-circle': XCircleIcon,
  documentation: DocumentationIcon,
  download: DownloadIcon,
  ellipsis: EllipsisIcon,
  'eye-off': EyeOffIcon,
  eye: EyeIcon,
  facebook: FacebookIcon,
  forbidden: ForbiddenIcon,
  'file-text': FileTextIcon,
  folder: FolderIcon,
  gift: GiftIcon,
  hash: HashIcon,
  headphones: HeadphonesIcon,
  heart: HeartIcon,
  'help-circle': HelpCircleIcon,
  home: HomeIcon,
  inbox: InboxIcon,
  info: InfoIcon,
  'life-buoy': LifeBuoyIcon,
  list: ListIcon,
  loader: ArcIcon,
  lock: LockIcon,
  'log-out': LogOutIcon,
  'map-pin': MapPinIcon,
  maximize: MaximizeIcon,
  'maximize-square': MaximizeSquareIcon,
  menu: MenuIcon,
  'message-round': MessageRoundIcon,
  'message-square': MessageSquareIcon,
  minimize: MinimizeIcon,
  move: MoveIcon,
  paperclip: PaperClipIcon,
  pause: PauseIcon,
  pencil: PencilIcon,
  phone: PhoneIcon,
  play: PlayIcon,
  'play-filled': PlayFilledIcon,
  plus: PlusIcon,
  road: RoadIcon,
  'rotate-ccw': RotateCCWIcon,
  settings: SettingsIcon,
  'shopping-cart': ShoppingCartIcon,
  send: SendIcon,
  star: StarIcon,
  'star-filled': StarFilledIcon,
  'thumbs-up': ThumbsUpIcon,
  'toggle-right': ToggleRightIcon,
  'trending-up': TrendingUpIcon,
  upload: UploadIcon,
  sun: SunIcon,
  sunrise: SunriseIcon,
  user: UserIcon,
  users: UsersIcon,
  volume: VolumeIcon,
  /** @deprecated: use volume icon instead  */
  'volume-2': VolumeIcon,
  'volume-x': VolumeMuteIcon,
  coins: CoinsIcon,
  trash: TrashIcon,
  timer: TimerIcon,
  wheel: WheelIcon,
  zap: ZapIcon,
  'zap-filled': ZapFilledIcon,
};
